import { Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useTheme, useToast } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import {
    APIS,
    PGEUIDS,
    SF_MENU_MGMT,
    SG_MENU_LANG_LIST,
    URLS,
} from "@/tra/tancis/ptli/ptl/menu/services/PtliMenuService";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const PTLI1001002S = (): JSX.Element => {
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0061"],
    });
    const toast = useToast();
    const modal = useModal();
    const navigate = useNavigate();
    const { theme } = useTheme();
    const langCodes = ["KO", "EN", "TZ"];
    const { uprMenuId } = useParams();
    const { getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0052" },
        ],
    });

    const form = { menuMgmt: useForm({ defaultSchema: SF_MENU_MGMT }) };

    const grid = { menuLangList: useGrid({ defaultSchema: SG_MENU_LANG_LIST }) };

    const fetch = {
        getChkMenuId: useFetch({
            api: (data: any) => APIS.getChkMenuId(data),
            onSuccess: (data: any) => {
                const { chkMenuId } = data;

                form.menuMgmt.handleSubmit(
                    () => {
                        if (!comnUtils.isEmpty(chkMenuId.content)) {
                            modal.openModal({ content: "msg.00005" }); // Duplicate data exists. !== 중복된 데이터가 존재합니다. ==!
                            form.menuMgmt.setError("menuId", { message: "msg.00005" }); // Duplicate data exists. !== 중복된 데이터가 존재합니다. ==!
                            return;
                        }

                        modal.openModal({
                            content: "msg.com.00047", // 저장하시겠습니까?
                            onConfirm: () => {
                                grid.menuLangList.clearData();

                                langCodes.forEach((langCd) => {
                                    const menuNm = form.menuMgmt.getValue(`menuNm${langCd}`);
                                    if (!comnUtils.isEmpty(menuNm))
                                        grid.menuLangList.addRow({ langCd: langCd, menuNm: menuNm });
                                });
                                fetch.createMenuMgmt.fetch();
                            },
                        });
                    },
                    () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid. !== 데이터가 유효하지 않습니다. ==!
                )();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // 조회가 실패하였습니다.
        }),
        getMenuInfo: useFetch({
            api: (data: any) => APIS.getMenuInfo(data),
            onSuccess: (data: { menuInfo: { content: any } }) => {
                const { menuLangList, ...info } = data.menuInfo.content;
                form.menuMgmt.setValue("bsopClsfCd", info.bsopClsfCd);
                form.menuMgmt.setValue("ptlTpCd", info.ptlTpCd);
                form.menuMgmt.setValue("uprMenuId", info.menuId);
                form.menuMgmt.setValue("uprMenuNm", info.menuNm);
                form.menuMgmt.setValue("menuOrd", 0);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // 조회가 실패하였습니다.
        }),
        createMenuMgmt: useFetch({
            api: () =>
                APIS.createMenuMgmt({
                    ...form.menuMgmt.getValues(),
                    bsopClsfCd: form.menuMgmt.getValue("bsopClsfCd"),
                    ptlTpCd: form.menuMgmt.getValue("ptlTpCd"),
                    menuLangList: grid.menuLangList.getData(),
                }),
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00062" }); // 정상적으로 저장되었습니다.
                handler.onListBtnClick();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00026" }), // 저장이 실패하였습니다.
        }),
    };

    const handler = {
        onListBtnClick: () => navigate(`${URLS.ptli1001001q}`),
        onMenuMgmtSaveBtnClick: () => {
            const menuId = form.menuMgmt.getValue("menuId");
            const ptlTpCd = form.menuMgmt.getValue("ptlTpCd");
            fetch.getChkMenuId.fetch({ menuId, ptlTpCd });
        },
    };

    useEffect(() => {
        const store = getStore(PGEUIDS.ptli1001001q);
        if (!comnUtils.isEmpty(store)) {
            form.menuMgmt.setValue("bsopClsfCd", store.bsopClsfCd);
            form.menuMgmt.setValue("ptlTpCd", store.ptlTpCd);
        }

        form.menuMgmt.setEditable(true);
        form.menuMgmt.setEditable("uprMenuNm", false);

        if (comnUtils.isEmpty(uprMenuId)) {
            form.menuMgmt.setValue("uprMenuNm", "ROOT");
            form.menuMgmt.setValue("uprMenuId", "menu_root");
            form.menuMgmt.setValue("menuOrd", 0);
        } else {
            fetch.getMenuInfo.fetch(uprMenuId);
        }

        grid.menuLangList.setData({ content: langCodes });
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.bsopClsfCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.uprMenuNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuOrd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuNmTZ} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuNmEN} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuNmKO} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section hidden={true}>
                        <Grid {...grid.menuLangList.grid} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"submit"} onClick={handler.onMenuMgmtSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
